import { useEffect, useState } from "react";
import { Loader2, Heart, Mail } from "lucide-react";
import { api } from "../../lib/api";
import { formatDate } from "../../lib/format";

export default function AdminMinistere() {
  const [dons, setDons] = useState(null);
  const [subs, setSubs] = useState(null);

  useEffect(() => {
    api.get("/admin/donations").then(({ data }) => setDons(data)).catch(() => setDons({ total: 0, count: 0, donations: [] }));
    api.get("/admin/newsletter").then(({ data }) => setSubs(data)).catch(() => setSubs([]));
  }, []);

  if (!dons || !subs) return <div className="py-20 flex justify-center"><Loader2 className="w-8 h-8 animate-spin text-brand" /></div>;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-heading text-3xl font-black tracking-tight text-brand-ink">Ministère</h1>
        <p className="text-brand-muted mt-1">Dons reçus et inscrits à l'application Bible.</p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
        <div className="bg-white border border-brand-line rounded-xl p-5">
          <p className="text-sm text-brand-muted">Total des dons</p>
          <p className="font-heading font-black text-2xl text-brand-ink mt-2" data-testid="donations-total">${dons.total.toLocaleString("en-US")}</p>
        </div>
        <div className="bg-white border border-brand-line rounded-xl p-5">
          <p className="text-sm text-brand-muted">Nombre de dons</p>
          <p className="font-heading font-black text-2xl text-brand-ink mt-2">{dons.count}</p>
        </div>
        <div className="bg-white border border-brand-line rounded-xl p-5">
          <p className="text-sm text-brand-muted">Inscrits Bible</p>
          <p className="font-heading font-black text-2xl text-brand-ink mt-2">{subs.length}</p>
        </div>
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        <div className="bg-white border border-brand-line rounded-xl p-6">
          <h3 className="font-heading font-semibold text-brand-ink mb-4 flex items-center gap-2"><Heart className="w-5 h-5 text-brand" /> Dons récents</h3>
          {dons.donations.length === 0 ? <p className="text-sm text-brand-muted">Aucun don pour l'instant.</p> : (
            <div className="space-y-2">
              {dons.donations.slice(0, 20).map((d) => (
                <div key={d.session_id} className="flex justify-between text-sm border-b border-brand-line pb-2">
                  <span className="text-brand-sub">{d.donor_email || "Anonyme"}<br /><span className="text-xs text-brand-muted">{formatDate(d.created_at)}</span></span>
                  <span className="font-semibold text-brand-ink">${d.amount}</span>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="bg-white border border-brand-line rounded-xl p-6">
          <h3 className="font-heading font-semibold text-brand-ink mb-4 flex items-center gap-2"><Mail className="w-5 h-5 text-brand-accent" /> Liste d'attente Bible</h3>
          {subs.length === 0 ? <p className="text-sm text-brand-muted">Aucun inscrit.</p> : (
            <div className="space-y-2 max-h-80 overflow-y-auto">
              {subs.map((s) => (
                <div key={s.id} className="flex justify-between text-sm border-b border-brand-line pb-2">
                  <span className="text-brand-sub">{s.email}</span>
                  <span className="text-xs text-brand-muted">{formatDate(s.created_at)}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
